import { isDelivery, isDeliveryExpress, isPickupStore, isPickupPoint, isNearestPickup, isDeliveryPremium } from './shipping-method.js';
import { ShippingMethod } from '../models/step-shipping/shipping-methods.js';

/**
 * Simple helper function to generate some summary info for the completed and overview steps.
 * This avoids some code duplication in these steps
 */ function getShippingMethodInfo(labels, shippingMethod, asides = {}) {
    if (isDelivery(shippingMethod)) {
        return {
            label: labels.delivery,
            aside: asides[ShippingMethod.Delivery]
        };
    }
    if (isDeliveryExpress(shippingMethod)) {
        return {
            label: labels.deliveryExpress,
            aside: asides[ShippingMethod.DeliveryExpress]
        };
    }
    if (isPickupStore(shippingMethod)) {
        return {
            label: labels.pickupStore,
            aside: asides[ShippingMethod.Pickup]
        };
    }
    if (isPickupPoint(shippingMethod)) {
        return {
            label: labels.pickupPoint,
            aside: asides[ShippingMethod.PickupPoint]
        };
    }
    if (isNearestPickup(shippingMethod)) {
        return {
            label: labels.nearestPickup,
            aside: asides[ShippingMethod.NearestPickup]
        };
    }
    if (isDeliveryPremium(shippingMethod)) {
        return {
            label: labels.deliveryPremium,
            aside: asides[ShippingMethod.DeliveryPremium]
        };
    }
    return {
        label: '',
        aside: null
    };
}

export { getShippingMethodInfo };
//# sourceMappingURL=get-shipping-method-info.js.map
